import { swatchHover } from './mous-product-form.js';

document.querySelectorAll('.product-form').forEach(form => {
    form.addEventListener('change', (event) => onVariantChange(event, form));

    swatchHover(form);
});

window.addEventListener('quickview-modal-opened', function () {
    document.querySelectorAll('.product-form').forEach(form => {
        form.addEventListener('change', (event) => onVariantChange(event, form, 'quickview'));
    });
});

window.addEventListener('quickview-modal-opened', function () {
    document.getElementById('main-product').addEventListener('change', onVariantChange);
});

document.addEventListener('click', function (e) {
    // setTimeout(updateRatingBars, 1000);
    if (e.target.classList.contains('btn__accessory')) {
        updateAddToCartText(e.target.closest('.product-form'));
    }
});

/**
 * Function to handle the change of variant selection.
 * @param {Object} event - The event object containing the target element.
 */
function onVariantChange(event, form, source) {
    let { target: optionValueElement } = event;

    // To handle differences between select and input elements
    if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        optionValueElement = selectedOption;
    }

    if (form) {
        // Get the product element and section ID from the parent section
        const productElement = form.querySelector('.product');
        const sectionId = productElement.dataset.sectionId;
        const whatsGreatAboutItSlider = document.querySelector('.mous-whats-great-slider-section');
        const whatsGreatAboutItSliderId = whatsGreatAboutItSlider?.getAttribute('id').replace('shopify-section-', '');
        // const whatsGreatAboutItSliderId = 'mous-whats-great-slider';

        // Get the old and new product URLs and new variant ID from the target element
        const newProductUrl = productElement.dataset.productUrl;
        const newVariantId = optionValueElement.dataset.variantId;
        const newVariantAvailable = optionValueElement.dataset.variantAvailable;

        // Get the current URL
        let currentUrl = new URL(window.location.href);
        if (newVariantId) {
            // Add or update the 'Variant' parameter with the new value
            currentUrl.searchParams.set('variant', newVariantId);

            // Update the browser's URL without reloading the page
            window.history.replaceState(null, '', currentUrl);
        } else {
            currentUrl.searchParams.delete('variant');
            window.history.replaceState({}, '', currentUrl);
        }
        let params = `sections=${sectionId},${whatsGreatAboutItSliderId},mous-accessories&`;

        // Set up the parameters for the section rendering API

        if (newVariantId) {
            // If the option value has a variant selection, call the section rendering API for that variant
            params += `variant=${newVariantId}`;
        } else {
            // If the option value selection has no variant, call the section rendering API with the selected option value IDs instead
            const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked, #choose-device select'))
                .map((element) => {
                    // If it's a select element, get the selected option's dataset
                    if (element.tagName === 'SELECT') {
                        return element.options[element.selectedIndex].dataset.optionValueId;
                    }
                    // If it's an input element, directly get its dataset
                    return element.dataset.optionValueId;
                })
                .filter(Boolean)  // Filter out any undefined or null values
                .join(',');

            params += `option_values=${selectedOptionValues}`;
        }

        if (document.querySelector('#main-product .gallery')) {
            document.querySelector('#main-product .gallery').querySelector('#main-product .gallery-container').style.opacity = 0;
        }

        // Call the section rendering API
        fetch(`${newProductUrl}?${params}`)
            .then((response) => response.json())
            .then((responseJSON) => {
                let concatenatedHTML = Object.values(responseJSON).join('');
                const html = new DOMParser().parseFromString(concatenatedHTML, 'text/html');

                const newOptionValueSelectors = html.querySelector('.product-options-form-wrapper');
                if (newOptionValueSelectors) {
                    form.querySelector('.product-options-form-wrapper').innerHTML = newOptionValueSelectors.innerHTML;
                }

                // Focus the input for the last clicked option value
                const optionValueElement = form.querySelector(`#${optionValueElement?.id}`);
                if (optionValueElement) {
                    optionValueElement.focus();
                }

                // Get the price element from the parent section
                const galleryEl = document.querySelector('#main-product .gallery');
                const priceEl = document.querySelector('#main-product .product-price');
                const categoryEl = document.querySelector('#main-product .product-category');
                const buttonWishlistEl = document.querySelector('#main-product .button-wishlist');
                const pdpBlocks = document.querySelector('#main-product .pdp-blocks');
                const whatsGreatAboutItSlider = document.querySelector('.mous-whats-great-slider-section');
                const accessoriesEl = document.querySelector('#main-product .accessories__container');

                if (whatsGreatAboutItSlider) {
                    const wgaiContainer = whatsGreatAboutItSlider.querySelector('.swiper-wrapper');
                    wgaiContainer.innerHTML = html.querySelector('.mous-whats-great-slider-section .swiper-wrapper').innerHTML;
                }

                if (accessoriesEl) {
                    accessoriesEl.innerHTML = html.querySelector('#main-product .accessories__container').innerHTML;
                }

                const productSubmitWrapper = form.querySelector('#main-product .product-submit-wrapper');
                if (productSubmitWrapper) { productSubmitWrapper.innerHTML = html.querySelector('#main-product .product-submit-wrapper').innerHTML; }

                const productSwatches = form.querySelector('#main-product .product-swatches-wrapper');
                if (productSwatches) { productSwatches.innerHTML = html.querySelector('#main-product .product-swatches-wrapper').innerHTML; }

                const secondVariantOptions = form.querySelector('#main-product .second-variant-options');
                if (secondVariantOptions) { secondVariantOptions.innerHTML = html.querySelector('#main-product .second-variant-options').innerHTML; }

                const stickySubmitButton = form.querySelector('#main-product .sticky-add-to-cart');
                if (stickySubmitButton) { stickySubmitButton.outerHTML = html.querySelector('#main-product .sticky-add-to-cart').outerHTML; }

                galleryEl.innerHTML = html.querySelector('#main-product .gallery').innerHTML;
                priceEl.innerHTML = html.querySelector('#main-product .product-price').innerHTML;
                categoryEl.innerHTML = html.querySelector('#main-product .product-category').innerHTML;
                if (buttonWishlistEl) { buttonWishlistEl.outerHTML = html.querySelector('#main-product .button-wishlist').outerHTML; }
                if (pdpBlocks) { pdpBlocks.innerHTML = html.querySelector('#main-product .pdp-blocks').innerHTML; }

                const scriptTag = galleryEl.querySelector('script');

                if (scriptTag) {
                    eval(scriptTag.innerHTML);
                }

                // yotpoWidgetsContainer.initWidgets();

                galleryEl.querySelector('#main-product .gallery-container').style.opacity = 1;
                updateAddToCartText();
                updateWidth();
                updateRatingBars();
                renderProductAccessories(newVariantId, newVariantAvailable);
                swatchHover(form);
                window.dispatchEvent(new CustomEvent('productFormRendered', { detail: newVariantId }));
                return;

            });
    }
}

if (document.getElementById('main-product')) {
    document.getElementById('main-product').addEventListener('change', onVariantChange);
}

document.addEventListener('click', function (e) {
    // UPDATE ADD TO CART TEXT - - - - - - - - - - - - - - - - - - - 
    const target = e.target;

    if (target.classList.contains('btn__accessory')) {
        updateAddToCartText();
    }
});

function updateRatingBars() {
    const ratingBars = document.querySelectorAll('.rating-bar');

    ratingBars.forEach((bar) => {
        const ratingValue = bar.getAttribute('data-rating');
        bar.style.setProperty('--rating-width', '0%');

        setTimeout(() => {
            bar.style.setProperty('--rating-width', `${ratingValue}%`);
        }, 100);
    });
}

// Update Add To Cart Text
function updateAddToCartText() {    
    console.log('updateAddToCartText');

    const submitButton = document.querySelector('#main-product [add-to-cart]');
    const stickySubmitButton = document.querySelector('#main-product .sticky-add-to-cart');
    const mainProductSelect = document.getElementById('mainProductSelect');

    let itemsToAdd = 0;
    let priceTotal = 0;
    let comparePriceTotal = 0;

    if (submitButton && submitButton.disabled != true && ( !mainProductSelect || ( mainProductSelect && mainProductSelect.selectedIndex != 0 ) ) ) {
        let addToCartText = submitButton.dataset.addToCartText;
        let addItemsToCartText = submitButton.dataset.addItemsToCartText;
        let addPreorderToCartText = submitButton.dataset.addPreorderToCartText;
        let addPreorderItemsToCartText = submitButton.dataset.addPreorderItemsToCartText;
        const isPreorder = submitButton.getAttribute('preorder') !== null;
        const addToCartPrice = parseFloat(submitButton.dataset.price) || 0;
        const addToCartComparePrice = parseFloat(submitButton.dataset.compareAtPrice) || addToCartPrice;

        // Sets default prices as product price or 0
        priceTotal = addToCartPrice;
        comparePriceTotal = addToCartComparePrice;

        // Sets Items to Add to 1
        itemsToAdd++;
        const addedBundleProducts = document.querySelectorAll('#main-product .accessories__wrapper .accessory__item.accessory__item--added .btn__accessory[add-accessory]');
        if (addedBundleProducts && addedBundleProducts.length > 0) {
            addedBundleProducts.forEach(bundleProduct => {
                const bundlePrice = parseFloat(bundleProduct.dataset.price) || 0;
                const bundleComparePrice = parseFloat(bundleProduct.dataset.compareAtPrice) || bundlePrice;
                if (bundlePrice <= 0) {
                    priceTotal += bundleComparePrice;
                } else {
                    // Update Total Price + Compare Prices
                    priceTotal += bundlePrice;
                }

                if (bundleComparePrice) comparePriceTotal += bundleComparePrice;

                // Update Items Added Count
                itemsToAdd++;
            });
        }

        // Format Total Prices 
        const priceTotalFormatted = Shopify.formatMoney(priceTotal);
        const comparePriceTotalFormatted = Shopify.formatMoney(comparePriceTotal);

        if (itemsToAdd > 1) {
            if (isPreorder != false) {
                addToCartText = addPreorderItemsToCartText.replace('{{ count }}', itemsToAdd);
            } else {
                addToCartText = addItemsToCartText.replace('{{ count }}', itemsToAdd);
            }
        } else {
            if (isPreorder != false) {
                addToCartText = addPreorderToCartText;
            }
        }

        let addToCartTextOutput = addToCartText;
        if (comparePriceTotal > priceTotal) {
            addToCartTextOutput = `
                ${addToCartText} 
                <span>-</span> 
                <span class="product-price-range-sale" style="text-decoration: line-through;">${comparePriceTotalFormatted}</span>
                <span class="product-price-range">${priceTotalFormatted}</span>
            `;
        } else {
            addToCartTextOutput = `
                ${addToCartText} 
                <span>-</span> 
                <span class="product-price-range">${priceTotalFormatted}</span>
            `;
        }

        submitButton.innerHTML = addToCartTextOutput;
        if (stickySubmitButton) stickySubmitButton.innerHTML = addToCartTextOutput;
    }
}

// Initial setup for rating bars
updateRatingBars();

function updateWidth() {
    const sourceElement = document.getElementById('productSectionWrapper');
    const targetElement = document.querySelector('.sticky-add-to-cart');

    if (sourceElement && targetElement) {
        if (window.innerWidth > 1400) {
            const sourceWidth = sourceElement.offsetWidth;
            targetElement.style.maxWidth = `${sourceWidth}px`;
        } else {
            if (targetElement) {
                targetElement.style.maxWidth = '';
            }
        }
    }
}
window.addEventListener('resize', updateWidth);
updateWidth();

if (!window.matchMedia("(pointer: coarse)").matches) {
    const targetElement = document.querySelector('.sticky-add-to-cart');
    if (targetElement) {
        targetElement.style.transform = 'translateX(8px)';
    }
}

const focusSelectADeviceElement = (event) => {
    const elementToFocus = document.getElementById('mainProductSelect');
    if (!elementToFocus) {
        console.error('Element with id mainProductSelect not found.');
        return;
    }

    const highlightElement = () => {
        elementToFocus.classList.add('highlight');
        setTimeout(() => {
            elementToFocus.classList.remove('highlight');
        }, 2000);
    };

    if (event && event.type !== 'quickview-select-a-device') {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    highlightElement();
                    observer.unobserve(elementToFocus);
                }
            });
        });

        observer.observe(elementToFocus);

        const elementPosition = elementToFocus.getBoundingClientRect().top;
        const offsetPosition = window.pageYOffset + elementPosition - 200;

        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    } else {
        highlightElement();
    }
};

document.querySelectorAll('[data-focus-select-a-device]').forEach(element => element && element.addEventListener('click', focusSelectADeviceElement));
window.addEventListener('quickview-select-a-device', focusSelectADeviceElement);


        
function renderProductAccessories(newVariantId, newVariantAvailable) {
    newVariantId ||= new URL(window.location.href).searchParams.get('variant') || '';
    const productSectionWrapper = document.querySelector('#productSectionWrapper');


    if (productSectionWrapper  && newVariantAvailable == 'true') {
        const productUrl = productSectionWrapper.dataset.productUrl;

        if (productUrl) {
            setTimeout(() => {
                fetch(`${productUrl}?sections=mous-accessories${newVariantId ? `&variant=${newVariantId}` : ''}`)
                .then((response) => response.json())
                .then((responseJSON) => {
                    const accessoriesMarkup = new DOMParser()
                        .parseFromString(responseJSON["mous-accessories"], 'text/html')
                        .querySelector(`#shopify-section-mous-accessories`).innerHTML;
                    
                    const accessoriesWrapper = document.querySelector('.accessories__container');
                    if (accessoriesWrapper) {
                        accessoriesWrapper.innerHTML = accessoriesMarkup;
                    }

                    window.dispatchEvent(new Event('productFormRendered'));
                })
            }, 2000);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const productSectionWrapper = document.querySelector('#productSectionWrapper');
    const variantId = productSectionWrapper ? productSectionWrapper.dataset.variantId : null;
    const variantAvailable = productSectionWrapper ? productSectionWrapper.dataset.variantAvailable: null;

    if (variantId && variantAvailable == 'true') {
        renderProductAccessories(variantId, variantAvailable);
    }
});
